
const getters = {
    returnUrl(state) {
        return state.returnUrl;
    },
    defaultReturnUrl(state) {
        return state.defaultReturnUrl;
    },
    familyOfBrandLinks(state) {
        return state.siteLinks.familyOfBrands;
    },
    copyrightLinks(state) {
        return state.siteLinks.copyright;
    },
    careerLinks(state) {
        return state.siteLinks.careers;
    },
    siteLinks: (state, getters) => {
        // hack: the LOGGED_IN and NOT_LOGGED_IN conditions require
        //       authentication state to evaluate. wrapping all condition delegates
        //       with a wrapper delegate that passes state in to the condition delegate.
        let links = JSON.parse(JSON.stringify(state.siteLinks.site));
        for (var i = 0; i < links.length; i++) {
            if (state.siteLinks.site[i].displayCondition) {
                let displayCondition = state.siteLinks.site[i].displayCondition;
                //let linkTitle = state.siteLinks.site[i].title;
                links[i].displayCondition = () => {
                    //console.log(`wrapping link '${linkTitle}' condition with state. displayCondition preview: ${displayCondition(getters.isAuthenticated)}`);
                    return displayCondition(getters.isAuthenticated);
                };
            }
        }
        return links;
    },
    navLinks: (state, getters) => {
        return getters.siteLinks.filter(({ nav }) => nav === true);
    },
    footerLinks: (state, getters) => {
        return getters.siteLinks.filter(({ foot }) => foot === true);
    },
    specificSiteLink: (state, getters) => (linkName) => {
        return getters.siteLinks.filter(({ title }) => title === linkName)[0] || { url: "unknown" };
    },
    support(state) {
        return state.support;
    },
    reviewPages(state) {
        var pageArray = [];
        var tmp = state.testimonials.reviews.slice(0);
        while (tmp.length) {
            pageArray.push(tmp.splice(0, state.testimonials.numberPerPage));
        }
        return pageArray;
    },
    reviews(state) {
        return state.testimonials.reviews;
    },
    isLockedout(state) {
        return state.webUser.isLockedout;
    },
    lockoutEndDate(state) {
        return state.webUser.lockOutEnd;
    },
    showFooter(state) {

        return state.showFooter;
    },
    twoFAEmail(state) {
        return state.twoFAEmail;
    },
    isNewRegistration(state) {
        return state.isNewRegistration;
    },
    newUserpassword(state) {
        return state.newUserpassword;
    },
    isUserInactive(state) {
        return state.isUserInactive;
    },
    paymentLink: (state, getters) => getters.siteLinks.find( ({ key }) => key === 'paymentLink' ).url,
};

export { getters };